/* RESPONSIBLE TEAM: team-automation-foundations */
import Model, { attr } from '@ember-data/model';

export default class MultilingualSettings extends Model {
  @attr('boolean') declare allLanguagesEnabled: boolean;
  @attr('boolean') declare fallbackSearchLocaleEnabled: boolean;
  @attr('string') declare fallbackSearchLocale: string;
}
